import React, { useMemo } from "react";
import { Spinner } from "reactstrap";
import { VsiBubbleFavs, VsiSpanText } from "../styled/App.styled";
import { useVsiAppContext } from "../stores/VsiApp";
import { useDataWithRoute } from "../utils/hooks";

// simplistic bookmark, I like it!
export default function StorageAllUnits() {

  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("STORAGE");

  const route = useMemo(() => `/api/v6/report/enterprise_all_units_count_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);
  const [{ recordset }, { isLoading }] = useDataWithRoute(route);

  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <VsiBubbleFavs>
      <div className={"d-flex flex-row justify-content-start align-items-center"}>
        {recordset.map((d, idx) => {
          return <VsiSpanText key={`descriptor-bookmark-${d.unit}-${idx}`} className={"pb-0 mb-0"}>
            <div style={{ paddingLeft: 25 }}>{d.count} {d.unit} </div>
          </VsiSpanText>;
        })}
      </div>
    </VsiBubbleFavs>
  );
}


